"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _pick2 = _interopRequireDefault(require("lodash/pick"));
var _notification = _interopRequireDefault(require("cccisd-icons/notification2"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var _default = function _default(props) {
  var field = props.field,
    form = props.form;
  var passingProps = (0, _pick2["default"])(props, ['autoFocus', 'autoComplete', 'type', 'style', 'id', 'disabled']);
  var passingField = _objectSpread(_objectSpread({}, field), !field.value && {
    value: ''
  });
  var error = form.errors[field.name];
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].wrapper + ' ' + (error ? _style["default"].hasError : '')
  }, error && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].error
  }, /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
    type: "error",
    placement: "right",
    title: error
  }, /*#__PURE__*/_react["default"].createElement(_notification["default"], null))), /*#__PURE__*/_react["default"].createElement("input", _extends({
    className: "form-control",
    type: "text"
  }, passingField, passingProps)));
};
exports["default"] = _default;